var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-1",on:{"click":_vm.clickHoliday}},[_vm._v("\n        Holiday - "+_vm._s(_vm.holidays.length ? _vm.holidays.length : "None")+"\n    ")]),_vm._v(" "),_c('logistics-holiday-info-modal',{ref:"modal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }